import { Stack, Typography } from "@mui/material";
import WushTextField from "../WushTextField";
import { addDays, addHours, format } from "date-fns";
import { useEffect, useState } from "react";
import Calendar from "@demark-pro/react-booking-calendar";
import WushDateTimeField from "../WushDateTimeField";

export default function ReservationScheduler({ setValue, reservation, bookableDuration }) {
  const [selectedStartDate, setSelectedStartDate] = useState(reservation?.start_at ? new Date(reservation.start_at): new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(reservation?.end_at ? new Date(reservation.end_at): new Date());

  const combineDateTime = (date, time) => {
    console.log(date);
    let dateString = date;
    if(dateString?.length > 12) dateString = format(new Date(date), 'yyyy-MM-dd');
    console.log(dateString);
    const timeString = format(new Date(time), 'HH:mm:ss');
    return new Date(`${dateString}T${timeString}`);
  };

  const addDateTime = (date, time, days) => {
    let dateString = date;
    if(dateString?.length > 12) dateString = format(new Date(date), 'yyyy-MM-dd');
    const timeString = format(new Date(time), 'HH:mm:ss');
    let addedDate = new Date(`${dateString}T${timeString}`);
    addedDate = addDays(addedDate, days);
    console.log(addedDate);
    return addedDate;
  };

  useEffect(() => {
    if(bookableDuration?.duration_type === 'scheduled') {
      setValue('start_at', combineDateTime(reservation.start_at || format(new Date(), 'yyyy-MM-dd'), bookableDuration.start_time));
      setValue('end_at', combineDateTime(reservation.end_at || format(new Date(), 'yyyy-MM-dd'), bookableDuration.end_time));
    } else if (bookableDuration?.duration_type === 'full_day') {
      setValue('start_at', combineDateTime(reservation.start_at || format(new Date(), 'yyyy-MM-dd'), bookableDuration.start_time));
      setValue('end_at', addDateTime(reservation.start_at || format(new Date(), 'yyyy-MM-dd'), bookableDuration.end_time, bookableDuration.days - 1));
    } else if (bookableDuration?.duration_type === 'hourly') {
      setValue('start_at', reservation.start_at);
      setValue('end_at', addHours(reservation.start_at, bookableDuration.hours));
    }
  }, [bookableDuration]);

  console.log(reservation);


  if(!bookableDuration) return null;

  if(bookableDuration.duration_type === 'hourly') {
    return (
      <Stack>
        <Stack mb={1} direction="row" spacing={1}>
          <WushDateTimeField
            defaultValue={reservation?.start_at || new Date()}
            onChange={(date) => {
              setValue('start_at', date, { shouldDirty: true });
              setValue('end_at', addHours(date, bookableDuration.hours), { shouldDirty: true });
            }}
          />
        </Stack>
      </Stack>
    );
  } else if(bookableDuration.duration_type === 'scheduled') {
    return (
      <Stack>
        <Stack mb={1} direction="row" spacing={1}>
          <Typography variant="body1" fontWeight="700">Start Time: </Typography>
          <Typography variant="body1">{format(new Date(bookableDuration.start_time), 'hh:mm aa')}</Typography>
        </Stack>
        <Stack mb={1}>
          <Typography variant="body1" fontWeight="700">Reservation date: </Typography>
          <WushTextField
            formRegistration={{
              onChange: (e) => {
                setValue('start_at', combineDateTime(e.target.value, bookableDuration.start_time), { shouldDirty: true });
                setValue('end_at', combineDateTime(e.target.value, bookableDuration.end_time), { shouldDirty: true });
              }
            }}
            type="date"
            defaultValue={reservation?.start_at ? format(new Date(reservation.start_at), 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd')}
          />
        </Stack>
      </Stack>
    );
  } else if(bookableDuration.duration_type === 'full_day') {
    return (
      <Stack>
        <Stack mb={1} direction="row" spacing={1}>
          <Typography variant="body1" fontWeight="700">Start Time: </Typography>
          <Typography variant="body1">{format(new Date(bookableDuration.start_time), 'hh:mm aa')}</Typography>
        </Stack>
        <Stack mb={1}>
          <Calendar
            onChange={(date) => {
              setValue('start_at', combineDateTime(format(date[0], 'yyyy-MM-dd'), bookableDuration.start_time), { shouldDirty: true });
              setValue('end_at', addDateTime(format(date[0], 'yyyy-MM-dd'), bookableDuration.end_time, bookableDuration.days - 1), { shouldDirty: true });
              setSelectedStartDate(date[0]);
              setSelectedEndDate(addDateTime(format(date[0], 'yyyy-MM-dd'), bookableDuration.end_time, bookableDuration.days - 1), { shouldDirty: true });
            }}
            selected={[selectedStartDate, selectedEndDate]}
            variant="events"
          />
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack>
    </Stack>
  );
}